import { TempoFilterConfig } from 'constants/filters';
import {
    getValueFromSliderPosition,
    getSliderPositionFromValue,
} from '../BpmSelector/components/TempoSliderController';

const { MaxSliderPosX } = TempoFilterConfig;

type BpmSliderState = {
    imperativePosition: number | undefined;
    initialBpm: number;
    selectedBpm: number;
    maxSliderPosition: number;
};

export type BpmSliderAction =
    | {
          type: 'RESET';
      }
    | {
          type: 'UPDATE_BPM';
          value: number;
      }
    | {
          type: 'UPDATE_POSITION';
          position: number;
      }
    | {
          type: 'UPDATE_SCALE';
          newMaxSliderPosition: number;
      };

export const initReducer = (
    initialBpm: number,
    maxSliderPosition: number = MaxSliderPosX,
): BpmSliderState => {
    const imperativePosition = getSliderPositionFromValue(
        initialBpm,
        maxSliderPosition,
    );

    return {
        initialBpm,
        imperativePosition,
        selectedBpm: initialBpm,
        maxSliderPosition,
    };
};

export const bpmSliderReducer = (
    state: BpmSliderState,
    action: BpmSliderAction,
): BpmSliderState => {
    const { initialBpm, selectedBpm, maxSliderPosition } = state;
    let imperativePosition;
    let value;
    let newMaxSliderPosition;

    switch (action.type) {
        case 'UPDATE_SCALE':
            ({ newMaxSliderPosition } = action);
            imperativePosition = getSliderPositionFromValue(
                selectedBpm,
                newMaxSliderPosition,
            );

            return {
                ...state,
                imperativePosition,
                maxSliderPosition: newMaxSliderPosition,
            };
        case 'RESET':
            imperativePosition = getSliderPositionFromValue(
                initialBpm,
                maxSliderPosition,
            );

            return { ...state, imperativePosition, selectedBpm: initialBpm };
        case 'UPDATE_BPM':
            imperativePosition = getSliderPositionFromValue(
                action.value,
                maxSliderPosition,
            );

            return { ...state, imperativePosition, selectedBpm: action.value };
        case 'UPDATE_POSITION':
            value = getValueFromSliderPosition(
                action.position,
                maxSliderPosition,
            );
            return {
                ...state,
                imperativePosition: undefined,
                selectedBpm: value,
            };
        default:
            return state;
    }
};
